import { createNotificationsStore, type NotificationsStore } from "@/stores/notificationsStore";
import { useClinicianAuthStore } from "@/stores/clinicianAuthStore";
import { getClinicianSocket } from "@/lib/clinicianSocket";
import { onResync } from "@/lib/socketRecovery";
import {
  listClinicianNotificationsApi,
  markAllClinicianNotificationsReadApi,
  markClinicianNotificationReadApi,
} from "@/portals/clinician/api/clinicianNotificationsApi";

let store: NotificationsStore | null = null;

/**
 * The clinician portal's own feed — clinician socket, session and endpoints.
 * Created on first use so a patient/admin session never instantiates the
 * clinician socket just because the shared bell module was imported.
 */
export const getClinicianNotificationsStore = (): NotificationsStore => (store ??= createNotificationsStore({
  list: listClinicianNotificationsApi,
  markRead: markClinicianNotificationReadApi,
  markAllRead: markAllClinicianNotificationsReadApi,
  onIncoming: (handler) => {
    getClinicianSocket().on("notification:new", handler);
  },
  onTokenChange: (handler) => {
    // Created lazily, so a clinician may already be signed in: report the current
    // token too — on the next microtask, since this runs inside zustand's
    // initializer where the store (and its fetch) doesn't exist yet.
    queueMicrotask(() => handler(useClinicianAuthStore.getState().accessToken));
    useClinicianAuthStore.subscribe((state) => handler(state.accessToken));
  },
  onResync: (handler) => {
    onResync(getClinicianSocket(), handler);
  },
}));
